export default class MatchQuizConfigModel {
    public enabled: boolean = false;
    public clientId: string = null;
    public defaultMarkets: string[] = null;
    public competitionsWhitelist: string[] = null;
}